import { PATH_API } from "constants/api";
import { ApiResponse } from "interfaces/models/api";
import { DataProjectModel } from "interfaces/models/dataProjectModel";
import { ProjectResourceInfo } from "libs/cache-project/types";
import { axiosECS } from "services/baseAxios";

const path = PATH_API.BIM_FILES;

export const getProjectList = async (params?: {
  onlyGetListName?: string;
  shouldCache?: boolean;
}): Promise<ApiResponse<any[]>> => {
  return axiosECS.get(path, { params });
};

export const getUsingBimFiles = async (): Promise<ApiResponse<string[]>> => {
  return axiosECS.get(`${path}/ids`);
};

export const getLastUpdatedResource = async (body: {
  bimFileId: string;
}): Promise<ApiResponse<ProjectResourceInfo[]>> => {
  return axiosECS.post(`${path}/last-updated-resources`, body);
};

export const createProject = async (body: any) => {
  return axiosECS.post(path, body);
};

export const updateProject = async (body: any) => {
  return axiosECS.patch(path, body);
};

export const getProject = async (
  bimFileId: string,
  useCache = false,
  shouldCache?: boolean
): Promise<ApiResponse<DataProjectModel>> => {
  return axiosECS.get(`${path}/${bimFileId}`, {
    params: {
      useCache,
      shouldCache,
    },
  });
};

export const deleteBimFileList = async (
  ids: string[]
): Promise<ApiResponse<string[]>> => {
  return axiosECS.delete(path, { data: { ids } });
};

export const updateSheetLevel = async (body: any) => {
  return axiosECS.patch(`${path}/sheet-level`, body);
};

export const updateDataGenerate = async (body: any) => {
  return axiosECS.patch(`${path}/data-generate`, body);
};
